export const API_GET_CONFIG_START = 'API_GET_CONFIG_START'
export const API_GET_CONFIG_SUCCESS = 'API_GET_CONFIG_SUCCESS'
export const API_GET_CONFIG_FAILURE = 'API_GET_CONFIG_FAILURE'
